var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3354 9.81344L12.8469 17.3134C12.7425 17.4183 12.6185 17.5015 12.482 17.5583C12.3454 17.6151 12.1991 17.6443 12.0512 17.6443C11.9034 17.6443 11.757 17.6151 11.6205 17.5583C11.4839 17.5015 11.3599 17.4183 11.2556 17.3134L3.76707 9.81344C3.55605 9.60209 3.4375 9.31545 3.4375 9.01656C3.4375 8.71767 3.55605 8.43103 3.76707 8.21969C3.97809 8.00834 4.2643 7.88961 4.56272 7.88961C4.86115 7.88961 5.14736 8.00834 5.35838 8.21969L12.0522 14.9237L18.7459 8.21875C18.957 8.0074 19.2432 7.88867 19.5416 7.88867C19.84 7.88867 20.1262 8.0074 20.3372 8.21875C20.5483 8.43009 20.6668 8.71674 20.6668 9.01562C20.6668 9.31451 20.5483 9.60115 20.3372 9.8125L20.3354 9.81344Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGrey);
export default __webpack_public_path__ + "static/media/chevron-down-grey.b504c1ad542ad97e9fbeeb2d2e3575c7.svg";
export { ForwardRef as ReactComponent };